import { MarketingPilotageHub } from '@/features/pilotage/MarketingPilotageHub';

export function MarketplaceCrmHubPage() {
  return (
    <div className="u-page">
      <div className="u-hero">
        <div>
          <p className="u-subtitle">
            CRM, chiffre d’affaires, fidélisation, marketplace et assistant IA marketing.
          </p>
        </div>
      </div>
      <MarketingPilotageHub />
    </div>
  );
}
